import React from 'react';
import { Icon } from 'Components';
import { OverviewCardProps } from 'LearningManager/components/OverviewCard';
import {
	ActivityAssignmentPriority,
	ActivityAssignmentStatus
} from 'Services/Api/UserDashboard/Types';
export type OverviewCardData = Omit<OverviewCardProps, 'tooltip'> & {
	id: string;
	tooltip: string;
};

export const ALL_FILTER_KEY = 'all';
export const REQUIRED_FILTER_KEY = 'required';
export const OPTIONAL_FILTER_KEY = 'optional';

type AllFilterKey = typeof ALL_FILTER_KEY;

export interface FilterOption<TKey extends string = string> {
	key: TKey;
	label: string;
}

export const PRIORITY_OPTIONS: FilterOption<
	ActivityAssignmentPriority | AllFilterKey
>[] = [
	{ key: ALL_FILTER_KEY, label: 'learning.courseAssignments.filters.priorityAll' },
	{ key: 'due_soon', label: 'learning.courseAssignments.filters.dueSoon' },
	{ key: 'overdue', label: 'learning.courseAssignments.filters.overdue' },
	{ key: 'no_due_date', label: 'learning.courseAssignments.filters.noDueDate' }
];

export const STATUS_OPTIONS: FilterOption<
	ActivityAssignmentStatus | AllFilterKey
>[] = [
	{ key: ALL_FILTER_KEY, label:'learning.courseAssignments.filters.allStates' },
	{ key: 'not_started', label: 'learning.courseAssignments.filters.notStarted' },
	{ key: 'in_progress', label: 'learning.courseAssignments.filters.inProgress' },
	{ key: 'completed', label: 'learning.courseAssignments.filters.completed' }
];

export const TYPE_OPTIONS: FilterOption[] = [
	{ key: ALL_FILTER_KEY, label: 'learning.courseAssignments.filters.allTypes' },
	{ key: REQUIRED_FILTER_KEY, label: 'learning.courseAssignments.filters.required' },
	{ key: OPTIONAL_FILTER_KEY, label: 'learning.courseAssignments.filters.optional' }
];

export const CATEGORY_OPTIONS: FilterOption[] = [
	{ key: ALL_FILTER_KEY, label: 'learning.courseAssignments.filters.allCategories' },
	{ key: 'core_essentials', label: 'learning.courseAssignments.filters.coreEssentials' },
	{ key: 'hospitality_specific', label: 'learning.courseAssignments.filters.hospitalitySpecific' },
	{ key: 'ai_driven', label: 'learning.courseAssignments.filters.aiDriven' }
];

export interface CourseData {
	id: number;
	title: string;
	meta: string;
	tags: string[];
	image: string;
	ctaLabel?: string;
}

export type LearningPathStatus = 'Required' | 'Scheduled' | 'In Progress' | 'Complete';

export interface LearningPathGroup {
	id: string;
	label: string;
	courses: CourseData[];
}

export interface LearningPathData {
	id: string;
	title: string;
	statuses: string[];
	courseCount: number;
	completedCount: number;
	completionPercentage: number;
	dueDate?: string;
	startsDate?: string;
	courses: CourseData[];
	learningPaths?: LearningPathGroup[];
	individualCourses?: CourseData[];
}

export interface CourseGroup {
	scope: string;
	label: string;
	courses: CourseData[];
}

export const OVERVIEW_CARDS_DATA: OverviewCardData[] = [
	{
		id: 'overall-completion',
		value: '77%',
		label: 'learning.overviewCards.overallCompletion.label',
		description: 'learning.overviewCards.overallCompletion.description',
		icon: <Icon type="warningCubeIcon" role="img" />,
		tooltip: 'learning.overviewCards.overallCompletion.tooltip'
	},
	{
		id: 'courses-remaining',
		value: 10,
		label: 'learning.overviewCards.coursesRemaining.label',
		description: 'learning.overviewCards.coursesRemaining.description',
		icon: <Icon type="grayCourseIcon" role="img" />,
		tooltip: 'learning.overviewCards.coursesRemaining.tooltip'
	},
	{
		id: 'courses-complete',
		value: 33,
		label: 'learning.overviewCards.coursesComplete.label',
		description: 'learning.overviewCards.coursesComplete.description',
		icon: <Icon type="tickBoxIcon" role="img" />,
		tooltip: 'learning.overviewCards.coursesComplete.tooltip'
	},
	{
		id: 'optional-course',
		value: 1,
		label: 'learning.overviewCards.optionalCourses.label',
		description: 'learning.overviewCards.optionalCourses.description',
		icon: <Icon type="optionalCourseIcon" role="img" />,
		tooltip: 'learning.overviewCards.optionalCourses.tooltip'
	}
];
